import React from 'react';

const Hero = () => {
    return (
        <div className="about-hero">
            <h1>We pioneered the discount broking model in India.<br />
            Now, we are breaking ground with our technology.</h1>
        </div>
    );
};

export default Hero;
